import React, { Reducer, useMemo, useReducer } from 'react';
import { ArticleContext } from '../hooks/useArticleContext';
import {
  ArticleAction,
  ArticleState,
  ArticlesReducer,
} from './ArticlesReducer';

type ArticleProviderProps = {
  children: React.ReactNode;
};

export const ArticleProvider = (props: ArticleProviderProps) => {
  const [state, dispatch] = useReducer<Reducer<ArticleState, ArticleAction>>(
    ArticlesReducer,
    { initial: true },
  );
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <ArticleContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </ArticleContext.Provider>
  );
};
